<div tabindex="101" *ngIf="appSuccess && !appError" class="ontario-row" aria-live="polite" aria-atomic="true"
    id="pageLevelMessageId" #pageMsg>
    <div class="ontario-columns ontario-small-12">

        <div class="ontario-alert ontario-alert--success">
            <div class="ontario-alert__header">
                <div class="ontario-alert__header-icon">
                    <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                        viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                        <use href="#ontario-icon-alert-success"></use>
                    </svg>
                </div>
                <h2 class="ontario-alert__header-title ontario-h4">{{'bss.success' | translate}}:</h2>
            </div>
            <div class="ontario-alert__body">
                <p [innerHTML]="appSuccessMessage | translate"></p>
            </div>
        </div>
    </div>
</div>

<div *ngIf="this.operation == 0" class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="public" />
        <h2 id="pageTitle"> {{ 'bss.admin.resetPassword.complete.title' | translate }}</h2>
        <hr>


        <p>{{ 'bss.admin.resetPassword.complete.content.first' | translate }}{{this.user.email}}{{
            'bss.admin.resetPassword.complete.content.second' | translate }}</p>

        <button tabindex="103" (click)="onSubmit()" class="ontario-button ontario-button--primary"
            title="{{ 'bss.admin.resetPassword.complete.button.title' | translate }}">
            {{ 'bss.admin.resetPassword.complete.button' | translate }}
        </button>
    </div>
</div>

<div *ngIf="this.operation == 1" class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="public" />
        <h2 id="pageTitle"> {{ 'bss.admin.resetPassword.complete.MPR.title' | translate }}</h2>
        <hr>


        <p>{{ 'bss.admin.resetPassword.MPR.complete.content.first' | translate }}{{this.user.email}}{{
            'bss.admin.resetPassword.MPR.complete.content.second' | translate }}{{this.storedCode}}{{
            'bss.admin.resetPassword.MPR.complete.content.third' | translate }}</p>
        <p>{{'bss.admin.resetPassword.MPR.complete.content.lostAccess.first'|translate}}{{this.user.email}}{{'bss.admin.resetPassword.MPR.complete.content.lostAccess.second'
            | translate}} <a tabindex="102" (click)="setAccess()"
                title="{{ 'bss.admin.resetPassword.MPR.complete.content.lostAccess.redirect.title' | translate }}">
                {{'bss.admin.resetPassword.MPR.complete.content.lostAccess.redirect' | translate }}
            </a>
        </p>

        <button tabindex="103" (click)="onSubmit()" class="ontario-button ontario-button--primary"
            title="{{ 'bss.admin.resetPassword.complete.button.title' | translate }}">
            {{ 'bss.admin.resetPassword.complete.button' | translate }}
        </button>
    </div>
</div>